import React, { useState, useRef, useEffect } from "react";
import { Bell } from "lucide-react";
import { useAuth } from "../../../contexts/AuthContext";
import { useUnreadCount } from "../../../hooks/useNotifications";
import { NotificationDropdown } from "./NotificationDropdown";
import { trackEvent } from "../../../utils/analytics";

export const NotificationBell = () => {
  const { isAuthenticated } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Poll for unread count only when authenticated
  const { data } = useUnreadCount(isAuthenticated);
  const unreadCount = data?.count || 0;

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  if (!isAuthenticated) return null;

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => {
          if (!isOpen) trackEvent("notification_bell_opened", { unread_count: unreadCount });
          setIsOpen(!isOpen);
        }}
        className={`relative p-2 rounded-full transition-colors ${
          isOpen ? "bg-indigo-50 text-indigo-600" : "text-gray-600 hover:bg-gray-100"
        }`}
        aria-label="Notifications"
      >
        <Bell size={20} className={unreadCount > 0 ? "animate-pulse" : ""} />
        
        {unreadCount > 0 && (
          <span className="absolute top-1 right-1 flex items-center justify-center min-w-[18px] h-[18px] px-1 text-[10px] font-bold text-white bg-rose-500 rounded-full border-2 border-white translate-x-1/4 -translate-y-1/4">
            {unreadCount > 99 ? "99+" : unreadCount}
          </span>
        )}
      </button>

      {isOpen && <NotificationDropdown onClose={() => setIsOpen(false)} />}
    </div>
  );
};
